<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Naikinimo akto formavimas</h3>

    <naikinimas-formavimas-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchFormavimas"
      @cancel="cancelFormavimas"
    />

    <template v-if="showResult">
      <v-alert class="mt-5" type="info" outlined :color="resultColor">
        {{ resultMsg }}
      </v-alert>
    </template>

    <template v-if="showList">
      <h4 class="mb-4">Naikintinų objektų sąrašas</h4>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="itemsList"
        :hide-default-footer="hideFooter"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
      >
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
      <v-footer class="form-footer">
        <el-button primary @click.native="saveData()" :loading="loading"
          >Formuoti naikinimo aktą</el-button
        >
      </v-footer>
    </template>
  </v-container>
</template>

<script>
import NaikinimasFormavimasSearch from './NaikinimasFormavimasSearch'

export default {
  name: 'NaikinimasFormavimas',
  components: {
    NaikinimasFormavimasSearch,
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      searchData: {},
      objektai: [],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      showList: false,
      showResult: false,
      resultMsg: null,
      resultColor: 'green',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Eil. Nr.',
          align: 'center',
          value: 'eilnr',
          sortable: false,
          width: 100,
        },
        {
          text: 'Objektas',
          align: 'start',
          sortable: false,
          value: 'obj_pavadinimas',
        },
        {
          text: 'Objekto identifikavimo kodas',
          align: 'start',
          sortable: false,
          value: 'obj_identifikavimo_kodas',
          width: 200,
        },
        {
          text: 'Įregistravimo data',
          align: 'center',
          sortable: false,
          value: 'obj_iregistravimo_data',
          width: 160,
        },
        {
          text: 'Išregistravimo data',
          align: 'center',
          sortable: false,
          value: 'obj_isregistravimo_data',
          width: 160,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.objektai.map((item, index) => {
        item.eilnr = index + 1
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    //this.getData()
  },
  methods: {
    searchFormavimas(searchData) {
      this.searchData = searchData
      this.showResult = false
      this.getData(true)
    },
    cancelFormavimas() {
      this.searchData = {}
      this.objektai = []
      this.showList = false
      this.showResult = false
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`naikinimo-aktas/paieska`, data)
        .then(res => {
          this.objektai = res.data.objektai
          this.pagination = { ...this.pagination, ...res.data.pagination }
          if (this.objektai.length === 0) {
            this.resultMsg = 'Nėra objektų, kuriuos galima sunaikinti'
            this.resultColor = 'red'
            this.showList = false
            this.showResult = true
            return
          }
          this.showList = true
        })
        .catch(err => {
          //window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.resultMsg = err.response.data.message
          this.resultColor = 'red'
          this.showList = false
          this.showResult = true
        })
        .finally(() => {
          this.loading = false
          // this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.pageloading) {
        this.paginationloading = true
        this.getData()
      }
      this.pageloading = false
    },
    saveData() {
      this.loading = true

      const data = {
        ...this.searchData,
      }

      this.$axios
        .post(`naikinimo-aktas`, data)
        .then(res => {
          // window._VMA.$emit('DATA_OK', res.data.message)
          this.resultMsg = res.data.message
          this.resultColor = 'green'
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.showList = false
          this.showResult = true
        })
    },
  },
}
</script>
